/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum CustomerSortingOption {
    NAME = 'Name',
    NUMBER = 'Number',
}
